/* Carrosséis com Slick e acordeão de conteúdo da caixa. */
(() => {
  'use strict';
  if (window.dysonProductCustom2026) return;
  window.dysonProductCustom2026 = true;

  const selector = '[data-dyson-lateral], [data-dyson-styles], [data-dyson-gallery]';
  const itemSelector = '.dyson-product-lateral__item, .dyson-product-styles__model, .dyson-product-gallery__item';
  const isStyles = (element) => element.hasAttribute('data-dyson-styles');
  const isGallery = (element) => element.hasAttribute('data-dyson-gallery');
  const mobile = window.matchMedia('(width < 750px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const sliders = new Set();

  // Especificações começam abertas; o recolhimento é exclusivo do mobile.
  function mountSpecifications(root) {
    root.querySelectorAll('[data-dyson-specs]').forEach((section) => {
      const button = section.querySelector('.dyson-product-specs__toggle');
      if (!button) return;
      button.hidden = false;
      section.setAttribute('data-specs-ready', '');
    });
  }
  function setSpecificationsOpen(section, open) {
    section.toggleAttribute('data-specs-closed', !open);
    section.querySelector('.dyson-product-specs__toggle').setAttribute('aria-expanded', String(open));
  }
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.dyson-product-specs__toggle');
    if (button && mobile.matches) setSpecificationsOpen(button.closest('[data-dyson-specs]'), button.getAttribute('aria-expanded') !== 'true');
  });
  document.addEventListener('shopify:section:load', (event) => mountSpecifications(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('[data-dyson-specs]');
    if (section) setSpecificationsOpen(section, true);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountSpecifications(document), { once: true });
  } else {
    mountSpecifications(document);
  }

  // Acordeão mobile independente de jQuery/Slick. Sem JS, a descrição segue visível.
  const boxSelector = '[data-box-collapsible]';
  function mountBoxItems(root) {
    root.querySelectorAll(boxSelector).forEach((item) => {
      const button = item.querySelector('.dyson-product-box__toggle');
      if (!button || item.hasAttribute('data-box-ready')) return;
      button.hidden = false;
      item.setAttribute('data-box-ready', '');
    });
  }

  function setBoxItemOpen(item, open) {
    if (open) {
      const list = item.closest('.dyson-product-box__items');
      list?.querySelectorAll('[data-box-open]').forEach((other) => {
        if (other !== item) setBoxItemOpen(other, false);
      });
    }
    item.toggleAttribute('data-box-open', open);
    item.querySelector('.dyson-product-box__toggle').setAttribute('aria-expanded', String(open));
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.dyson-product-box__toggle');
    if (!button || !mobile.matches) return;
    const item = button.closest(boxSelector);
    if (item) setBoxItemOpen(item, button.getAttribute('aria-expanded') !== 'true');
  });
  document.addEventListener('shopify:section:load', (event) => mountBoxItems(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest(boxSelector);
    if (item) setBoxItemOpen(item, true);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountBoxItems(document), { once: true });
  } else {
    mountBoxItems(document);
  }

  const $ = window.jQuery;
  // O fallback CSS permite deslizar as imagens mesmo se Slick não estiver disponível.
  if (!$ || !$.fn.slick) return;

  const arrow = (prefix, direction, label, path) =>
    `<button type="button" class="${prefix}__arrow ${prefix}__arrow--${direction}" aria-label="${label}"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="${path}" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`;

  function labelDots(element) {
    $(element).find('.slick-dots button').each(function (index) {
      this.setAttribute('aria-label', `Ir para ${isGallery(element) ? 'banner' : isStyles(element) ? 'modelo' : 'imagem'} ${index + 1}`);
    });
  }

  function synchronize(element) {
    const slider = $(element);
    if (!mobile.matches && !isGallery(element)) {
      if (slider.hasClass('slick-initialized')) slider.slick('unslick');
      element.removeAttribute('aria-roledescription');
      return;
    }
    if (slider.hasClass('slick-initialized')) return;
    const slideSelector = isGallery(element) ? '.dyson-product-gallery__item' : isStyles(element) ? '.dyson-product-styles__model' : '.dyson-product-lateral__item';
    const prefix = isGallery(element) ? 'dyson-product-gallery' : isStyles(element) ? 'dyson-product-styles' : 'dyson-product-lateral';
    const count = element.querySelectorAll(`:scope > ${slideSelector}`).length;
    if (count < 2) return;
    element.setAttribute('aria-roledescription', 'carrossel');
    slider.slick({
      slide: slideSelector,
      rows: 0,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: true,
      autoplay: false,
      fade: isGallery(element),
      cssEase: isGallery(element) ? 'ease-in-out' : 'ease',
      adaptiveHeight: false,
      accessibility: true,
      swipe: true,
      touchMove: true,
      speed: reducedMotion.matches ? 0 : isGallery(element) ? 450 : 300,
      lazyLoad: false,
      prevArrow: arrow(prefix, 'prev', isGallery(element) ? 'Banner anterior' : isStyles(element) ? 'Modelo anterior' : 'Imagem anterior', 'M10 3 5 8l5 5'),
      nextArrow: arrow(prefix, 'next', isGallery(element) ? 'Próximo banner' : isStyles(element) ? 'Próxima modelo' : 'Próxima imagem', 'm6 3 5 5-5 5'),
      customPaging: (_, index) => `<button type="button" aria-label="Ir para imagem ${index + 1}"></button>`,
    });
    // Cópias visuais do Slick não devem duplicar blocos selecionáveis no editor.
    slider.find('.slick-cloned').removeAttr('data-shopify-editor-block');
    labelDots(element);
  }

  function mount(root) {
    const elements = [...root.querySelectorAll(selector)];
    if (root.matches && root.matches(selector)) elements.unshift(root);
    elements.forEach((element) => {
      if (!sliders.has(element)) {
        sliders.add(element);
        $(element).on('afterChange.dysonProduct', () => {
          // Slick atualiza seus atributos de acessibilidade após emitir afterChange.
          queueMicrotask(() => labelDots(element));
        });
      }
      synchronize(element);
    });
  }

  function unmount(root) {
    sliders.forEach((element) => {
      if (root === element || root.contains(element)) {
        const slider = $(element);
        slider.off('.dysonProduct');
        if (slider.hasClass('slick-initialized')) slider.slick('unslick');
        sliders.delete(element);
      }
    });
  }

  mobile.addEventListener('change', () => sliders.forEach(synchronize));
  reducedMotion.addEventListener('change', () => {
    sliders.forEach((element) => {
      if ($(element).hasClass('slick-initialized')) {
        $(element).slick('slickSetOption', 'speed', reducedMotion.matches ? 0 : isGallery(element) ? 450 : 300);
      }
    });
  });
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => unmount(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest(itemSelector);
    const element = item && item.closest(selector);
    if (!element || !$(element).hasClass('slick-initialized')) return;
    const slick = $(element).slick('getSlick');
    const index = slick.$slides.index(item);
    if (index >= 0) {
      // A seleção do editor precisa funcionar mesmo durante uma transição.
      const waitForAnimate = slick.options.waitForAnimate;
      slick.options.waitForAnimate = false;
      $(element).slick('slickGoTo', index, true);
      slick.options.waitForAnimate = waitForAnimate;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  } else {
    mount(document);
  }
})();
